import {createErrorAction} from './utils';

const TYPES = {
    GET_TOP_PERFORMING_GAMES: 'GET_TOP_PERFORMING_GAMES',
    GET_TOP_PERFORMING_GAMES_COMPLETE: 'GET_TOP_PERFORMING_GAMES_COMPLETE',
    GET_TOP_PERFORMING_GAMES_FAILED: 'GET_TOP_PERFORMING_GAMES_FAILED'
};

export default {
    TYPES,

    getTopPerformingGames: payload => ({
        type: TYPES.GET_TOP_PERFORMING_GAMES,
        payload
    }),

    getTopPerformingGamesSuccess: payload => ({
        type: TYPES.GET_TOP_PERFORMING_GAMES_COMPLETE,
        payload
    }),

    getTopPerformingGamesFailed: createErrorAction(TYPES.GET_TOP_PERFORMING_GAMES_FAILED)
};
